import BookmarkMenu from "../../models/bookmarkMenu";
import BookmarkFolder from "../../models/bookmarkFolder";
import BookmarkLink from "../../models/bookmarkLink";
import BookmarkFolderProvider from "../../providers/bookmarkFolderProvider";
import BookmarkLinkProvider from "../../providers/bookmarkLinkProvider";
import IBookmarkFolder from "../../interfaces/bookmarkFolderInterface";
import Vue from "vue";

const folderProvider = new BookmarkFolderProvider(
  BookmarkFolder,
  'bookmark_folder',
  'account/bookmark_menu/bookmark_folders'
);

const linkProvider = new BookmarkLinkProvider(
  BookmarkLink,
  'bookmark_link',
  'account/bookmark_menu/bookmark_folders/:bookmark_folder_id/bookmark_links'
);

export default function () {
  return {
    namespaced: true,
    state: {
      bookmarkMenu: null,
    },
    mutations: {
      setBookmarkMenu(state, bookmarkMenu) {
        state.bookmarkMenu = bookmarkMenu;
      },
      addBookmarkFolder(state, {bookmarkFolder, bookmarkFolderJson}) {
        bookmarkFolder.loadFromJson(bookmarkFolderJson);
        state.bookmarkMenu.bookmark_folders.push(bookmarkFolder);
      },
      updateBookmarkFolder(state, {bookmarkFolder, bookmarkFolderJson}) {
        bookmarkFolder.loadFromJson(bookmarkFolderJson);
      },
      removeBookmarkFolder(state, {bookmarkFolder}) {
        const bookmarkFolders = state.bookmarkMenu.bookmark_folders;
        bookmarkFolders.splice(bookmarkFolders.indexOf(bookmarkFolder), 1);
      },
      addBookmarkLink(state, {bookmarkLink, bookmarkLinkJson}) {
        bookmarkLink.loadFromJson(bookmarkLinkJson);

        const bookmarkFolder = state.bookmarkMenu.bookmark_folders.find(bf => bf.id === bookmarkLink.bookmark_folder_id);
        bookmarkLink.parent = bookmarkFolder;
        bookmarkFolder.bookmark_links.push(bookmarkLink);
      },
      updateBookmarkLink(state, {bookmarkLink, bookmarkLinkJson}) {
        // NOTE: currently does not handle reparenting
        bookmarkLink.loadFromJson(bookmarkLinkJson);
      },
      removeBookmarkLink(state, {bookmarkLink}) {
        const bookmarkFolder = state.bookmarkMenu.bookmark_folders.find(bf => bf.id === bookmarkLink.bookmark_folder_id);
        const bookmarkLinks = bookmarkFolder.bookmark_links;
        bookmarkLinks.splice(bookmarkLinks.indexOf(bookmarkLink), 1);
      },
      setCurrentQuery(state, val) {
        Vue.set(state, "currentQuery", val);
      },
    },
    actions: {
      createBookmarkFolder({commit, state}, {bookmarkFolder}: {bookmarkFolder: BookmarkFolder}) {
        return new Promise((resolve, reject) => {
          folderProvider.save(bookmarkFolder).then(result => {
            const bookmarkFolderJson = result[0];
            commit('addBookmarkFolder', {bookmarkFolder, bookmarkFolderJson});
            resolve(bookmarkFolder);
          });
        });
      },
      updateBookmarkFolder({commit, state}, {bookmarkFolder}: {bookmarkFolder: BookmarkFolder}) {
        return new Promise((resolve, reject) => {
          folderProvider.save(bookmarkFolder).then(result => {
            const bookmarkFolderJson = result[0];
            commit('updateBookmarkFolder', {bookmarkFolder, bookmarkFolderJson});
            resolve(bookmarkFolder);
          });
        });
      },
      destroyBookmarkFolder({commit, state}, {bookmarkFolder}: {bookmarkFolder: BookmarkFolder}) {
        return new Promise((resolve, reject) => {
          folderProvider.destroy(bookmarkFolder).then(result => {
            const bookmarkFolderJson = result[0];
            commit('removeBookmarkFolder', {bookmarkFolder});
            resolve(bookmarkFolderJson);
          });
        });
      },
      createBookmarkLink({commit, state}, {bookmarkLink}: {bookmarkLink: BookmarkLink}) {
        return new Promise((resolve, reject) => {
          linkProvider.save(bookmarkLink).then(result => {
            const bookmarkLinkJson = result[0];
            commit('addBookmarkLink', {bookmarkLink, bookmarkLinkJson});
            resolve(bookmarkLink);
          });
        });
      },
      updateBookmarkLink({commit, state}, {bookmarkLink}: {bookmarkLink: BookmarkLink}) {
        return new Promise((resolve, reject) => {
          linkProvider.save(bookmarkLink).then(result => {
            const bookmarkLinkJson = result[0];
            commit('updateBookmarkLink', {bookmarkLink, bookmarkLinkJson});
            resolve(bookmarkLink);
          });
        });
      },
      changeBookmarkLinkParent({commit, state, dispatch}, {bookmarkLink, newBookmarkFolder}) {
        bookmarkLink.move_to_bookmark_folder_id = newBookmarkFolder.id;
        dispatch('updateBookmarkLink', {bookmarkLink});

        const previousFolder = bookmarkLink.parent;
        const previousIndex = previousFolder.bookmark_links.indexOf(bookmarkLink);
        previousFolder.bookmark_links.splice(previousIndex, 1)

        bookmarkLink.parent = newBookmarkFolder;
        bookmarkLink.bookmark_folder_id = newBookmarkFolder.id;

        newBookmarkFolder.bookmark_links.push(bookmarkLink);
      },
      destroyBookmarkLink({commit, state}, {bookmarkLink}: {bookmarkLink: BookmarkLink}) {
        return new Promise((resolve, reject) => {
          linkProvider.destroy(bookmarkLink).then(result => {
            const bookmarkFolderJson = result[0];
            commit('removeBookmarkLink', {bookmarkLink});
            resolve(bookmarkFolderJson);
          });
        });
      },
    },
  };
}
